import { createFileRoute, redirect } from '@tanstack/react-router'
import { CategoriesPage } from '../pages/CategoriesPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/categories' as any)({
    component: CategoriesPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
